import React, { useState } from 'react'
import ScrollToTop from '../components/ScrollToTop';
import Footer from '../components/Footer';
import VideoPlayer from '../components/VideoPlayer'
import NavbarHeader from '../components/NavbarHeader';
import { Account } from '../components/Accounts';
import Discussion from '../components/DiscussionForms';

function DiscussionPage() {

    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => {
        setIsOpen(!isOpen);
    };


    return (
        <div className='discussion'>
            <Account>
                <ScrollToTop />
                <NavbarHeader toggle={toggle} />
                <Discussion />
                <Footer />
            </Account>
        </div>
    );
}

export default DiscussionPage;